module.exports = __webpack_public_path__ + "img/payment-visa.264d18e6.svg";